import React from "react";
import { CustomHeader } from 'react-calendar-timeline' // new

/**
 * Returns the hourly header that will be visible in the one to two day schedule. It changes based on the size of the screen.
 * @param {*} param0 
 */
const CustomHourlyHeader = () => {
  return (
    < CustomHeader unit="hour">
    {({
      headerContext: { intervals },
      getRootProps,
      getIntervalProps,
      showPeriod
    }) => {
      // let intervalCount = intervals.length
      // let rogueValue = 0
      // while(intervalCount--){
      //   if(intervalCount > 0 && 
      //     intervals[intervalCount].startTime.format('ha').slice(0, -1) == intervals[intervalCount-1].startTime.format('ha').slice(0,-1)){
      //     rogueValue = intervalCount
      //     break;
      //   }
      // }
      // if(rogueValue > 0) {
      //   for(let i = rogueValue+1; i < intervals.length; i++){
      //     intervals[i].left = intervals[i].left - intervals[i].labelWidth
      //   }
      //   intervals.splice(rogueValue,1)
      // }
      return (
        <div {...getRootProps({ style: { height: 10, fontSize: 10 } })}>
          {intervals.map((interval, index, array) => {
            const intervalStyle = {
              // height: 30,
              lineHeight: '30px',
              textAlign: 'center',
              borderLeft: '0.25px solid gray',
              borderTop: '0.5px solid gray',
              // cursor: 'pointer',
              backgroundColor: 'darkgray',
              color: 'white'
            }
            // interval.startTime=interval.startTime.utc(true)
            // interval.endTime=interval.endTime.utc(true)
            return (
              <div
                // onClick={() => {
                //   showPeriod(interval.startTime, interval.endTime)
                // }}
                {...getIntervalProps({
                  interval,
                  style: intervalStyle
                })}
              >
                <div className="sticky">
                  {interval.startTime.format('ha').slice(0, -1)}
                </div>
              </div>
            )
          })}
        </div>
      )
    }}
    </CustomHeader>
  )
}

export default CustomHourlyHeader;
